<script setup lang="ts">
import { ref, computed } from "vue";

import { useSiteOperationalDataStore } from "../../store/siteOperationalData.store";
const siteOperationalStore = useSiteOperationalDataStore();

const props = defineProps({
  element: {
    type: Object,
    required: true,
  },
  selectChoice: {
    type: Function,
    required: false,
  },
  isExtended: {
    type: Boolean,
    default: false,
  },
  forceCloseSubmenu: {
    type: Boolean,
    default: false,
  },
  dropdownTop: {
    type: Number,
    default: 0,
  },
  isComboParam: {
    type: Boolean,
    default: false,
  },
  displayValue: {
    type: String,
    default: "label",
    required: false,
  },
  displayValueOther: {
    type: String,
    default: "",
    required: false,
  }
});

const emit = defineEmits([
  "selectedChoice",
  "openModalProfil",
  "logout",
  "forceCloseMenu",
  "forceCloseSubMenu",
]);
const selectedValue = ref();
const isSubmenuOpen = ref(false);
const isDropdownOpen = ref(false);
const isDropdownState = computed(() =>
  props.element.isOpen !== undefined ? props.element.isOpen : isSubmenuOpen,
);

interface OptionSelectionDropdown {
  label: string;
  icon: string;
  isSelected: boolean;
  isOpen: boolean;
}

const clickAction = (value: OptionSelectionDropdown) => {
  //selectedValue.value = value;
  //emit('selectedChoice', value)
  if (value.submenu) {
    isSubmenuOpen.value = !isSubmenuOpen.value;
  }
  if (props.selectChoice) {
    selectedValue.value = value;
    emit("selectedChoice", value);
    emit("forceCloseMenu");
    props.selectChoice ? props.selectChoice(value) : "";
  } else {
    isDropdownOpen.value = !isDropdownOpen.value;
  }
  if (value.action) {
    switch (value.action) {
      case "openProfil":
        emit("openModalProfil");
        break;
      case "logout":
        emit("logout");
        break;
    }
  }
};

const handlePosition = (e) => {
  if (!props.isExtended) {
    const parentTop = e.target
      .closest(".dropdown-button__container--list")
      .getBoundingClientRect().y;
    e.target
      .closest(".dropdown-button__container--list")
      .querySelector(".submenu__container").style.top = `${parentTop}px`;
  }
};

const forceCloseSubmenu = (labelPage : string, isSubMenu : boolean = false) => {

  siteOperationalStore.setCurrentPage(labelPage);

  if(isSubMenu) {
    emit("forceCloseSubMenu","item");
  } else {
    emit("forceCloseMenu","item");
  }

};
</script>

<template>
  <li
    @click="clickAction(element)"
    v-on:click="handlePosition"
    class="dropdown-button__container--list"
    :class="{
      selected: element.isSelected,
      'dropdown-button__container--list--fixed': !props.isExtended,
    }"
  >
    <div :class="{ 'div--img' : element.icon }">
      <img
        v-if="element.icon"
        :src="`/images/${element.icon}`"
        :alt="element.icon"
        class="dropdown-button__container__list--img"
      />
      <p
        class="dropdown-button__container__list-label"
        v-if="!element.path && props.isComboParam"
      >
      <span v-if="props.displayValueOther == ''">
          {{ element?.[props.displayValue] }}
        </span>
        <span v-else>
          {{ element?.[props.displayValue] }} -  {{ element?.['geneticType'][props.displayValueOther] }}
        </span>
      </p>
      <p
        class="dropdown-button__container__list-label"
        v-if="!element.path && !props.isComboParam"
      >
        {{ element.label }}

        <img
      src="/src/assets/images/chevron.svg"
      alt="chevron"
      v-if="element.submenu"
      class="submenu--chevron img--right"
      style="align: left;"
    />

      </p>
      <a
        class="dropdown-button__container__list-label"
        v-if="element.path"
        :href="'/#' + element.path"
        @click="forceCloseSubmenu(element.label)"
        >{{ element.label }}</a
      >
    </div>
    <img
      src="/src/assets/images/check.svg"
      v-if="element.isSelected"
      alt="image check"
    />
    
    <ul
      v-show="isDropdownState"
      class="submenu__container"
      :class="{
        'submenu__container--open': isSubmenuOpen,
        'submenu__container--none': !element.submenu,
      }"
    >
      <template
        v-for="submenu in element.submenu"
        :key="submenu.label"
        class="submenu--item dropdown-button__container--list"
      >
      <p class="dropdown-button__container__list-label" v-if="!submenu.path">{{ submenu.label }}</p>
      <a class="dropdown-button__container__list-label" v-if="submenu.path" :href="'/#' + submenu.path" @click="forceCloseSubmenu(submenu.label, true)">{{ submenu.label }}</a>
      </template>
    </ul>
  </li>
</template>

<style lang="scss">
@use "../../assets/css/utils/_variables.scss" as *;

.dropdown-button__container__list {

  &--img {
    margin-right: 8px;
  }

  &-label {
    color: unset;
    text-decoration: none;
    margin: 0;

  }
}

.img--right {
  float: right;
  padding-top: 15px;
}

.dropdown-button__container--list {
  list-style: none;
  //display: flex;
  
  justify-content: space-between;
  align-items: center;
  //padding: 0 8px;
  font-size: 14px;
  position: relative;

  a, p {
      padding: 8px 8px;
  }
  

  &--fixed {
    //padding: 8px;

    .submenu__container {
      position: fixed !important;
      left: 1.5rem !important;
      transform: translateX(100%);
    }
  }

  div {
    //display: flex;
    align-items: center;
  }

  .div--img {
    display: flex;
  }

  a {
    display: block;
  }

  &:hover {
    background-color: $blue;
    color: $white;
    cursor: pointer;
    img {
      filter: brightness(0) invert(1);
    }
  }

  .submenu__container {
    list-style: none;
    position: absolute;
    left: 100%;
    top: 0;
    background-color: $black-grey;
    min-width: max-content;
    width: 229px;
    font-size: 14px;
    line-height: 20px;
    margin-top: 0;

    &--none {
      display: none;
    }

    a {
      padding: 8px 16px;

      &:hover {
      background-color: $blue;
      color: $white;
      cursor: pointer;
      img {
        filter: brightness(0) invert(1);
      }
  }

    }

    li {
      //padding: 8px 16px;
      a {
        color: $white;
        text-decoration: none;
      }
    }
  }
}
</style>